/* tslint:disable */
/* eslint-disable */
/**
 * grpc/tracker/assistant.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { RpcStatus } from '../models'
// @ts-ignore
import type { TrackerAssistantThread } from '../models'
// @ts-ignore
import type { TrackerCreateThreadRequest } from '../models'
// @ts-ignore
import type { TrackerListMessagesResponse } from '../models'
// @ts-ignore
import type { TrackerListThreadsResponse } from '../models'
/**
 * AssistantServiceApi - axios parameter creator
 */
export const AssistantServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Opens a conversation about a context: an issue, a project, a page, or nothing in particular.
     * @param {TrackerCreateThreadRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assistantServiceCreateThread: async (
      body: TrackerCreateThreadRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('assistantServiceCreateThread', 'body', body)
      const localVarPath = `/api/v1/tracker/assistant/threads`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Deletes a thread with its messages. Nothing here is worth keeping against the owner\'s wish.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assistantServiceDeleteThread: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('assistantServiceDeleteThread', 'id', id)
      const localVarPath = `/api/v1/tracker/assistant/threads/{id}`.replace(
        '{id}',
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns one thread. Someone else\'s thread reads as missing, not as denied: the answer must not tell whether it exists.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assistantServiceGetThread: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('assistantServiceGetThread', 'id', id)
      const localVarPath = `/api/v1/tracker/assistant/threads/{id}`.replace(
        '{id}',
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns the whole thread in order, tool calls included: without them the conversation reads as if answers appeared out of nowhere.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assistantServiceListMessages: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('assistantServiceListMessages', 'id', id)
      const localVarPath = `/api/v1/tracker/assistant/threads/{id}/messages`.replace(
        '{id}',
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists the caller\'s own threads, newest activity first. Filter by context to get the conversations that belong to the screen the person is on.
     * @param {AssistantServiceListThreadsContextTypeEnum} [contextType] Both empty — every thread of the caller. Set together to narrow down to one screen.   - ASSISTANT_CONTEXT_TYPE_NONE: Started from nowhere in particular — the command palette on a general screen.
     * @param {string} [contextKey]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assistantServiceListThreads: async (
      contextType?: AssistantServiceListThreadsContextTypeEnum,
      contextKey?: string,
      limit?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/tracker/assistant/threads`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (contextType !== undefined) {
        localVarQueryParameter['contextType'] = contextType
      }

      if (contextKey !== undefined) {
        localVarQueryParameter['contextKey'] = contextKey
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      localVarHeaderParameter['Accept'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * AssistantServiceApi - functional programming interface
 */
export const AssistantServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AssistantServiceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Opens a conversation about a context: an issue, a project, a page, or nothing in particular.
     * @param {TrackerCreateThreadRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assistantServiceCreateThread(
      body: TrackerCreateThreadRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerAssistantThread>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assistantServiceCreateThread(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AssistantServiceApi.assistantServiceCreateThread']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Deletes a thread with its messages. Nothing here is worth keeping against the owner\'s wish.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assistantServiceDeleteThread(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assistantServiceDeleteThread(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AssistantServiceApi.assistantServiceDeleteThread']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns one thread. Someone else\'s thread reads as missing, not as denied: the answer must not tell whether it exists.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assistantServiceGetThread(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerAssistantThread>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assistantServiceGetThread(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AssistantServiceApi.assistantServiceGetThread']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns the whole thread in order, tool calls included: without them the conversation reads as if answers appeared out of nowhere.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assistantServiceListMessages(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerListMessagesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assistantServiceListMessages(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AssistantServiceApi.assistantServiceListMessages']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists the caller\'s own threads, newest activity first. Filter by context to get the conversations that belong to the screen the person is on.
     * @param {AssistantServiceListThreadsContextTypeEnum} [contextType] Both empty — every thread of the caller. Set together to narrow down to one screen.   - ASSISTANT_CONTEXT_TYPE_NONE: Started from nowhere in particular — the command palette on a general screen.
     * @param {string} [contextKey]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assistantServiceListThreads(
      contextType?: AssistantServiceListThreadsContextTypeEnum,
      contextKey?: string,
      limit?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TrackerListThreadsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assistantServiceListThreads(
        contextType,
        contextKey,
        limit,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AssistantServiceApi.assistantServiceListThreads']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * AssistantServiceApi - factory interface
 */
export const AssistantServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = AssistantServiceApiFp(configuration)
  return {
    /**
     *
     * @summary Opens a conversation about a context: an issue, a project, a page, or nothing in particular.
     * @param {TrackerCreateThreadRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assistantServiceCreateThread(
      body: TrackerCreateThreadRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerAssistantThread> {
      return localVarFp
        .assistantServiceCreateThread(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Deletes a thread with its messages. Nothing here is worth keeping against the owner\'s wish.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assistantServiceDeleteThread(
      id: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<object> {
      return localVarFp
        .assistantServiceDeleteThread(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns one thread. Someone else\'s thread reads as missing, not as denied: the answer must not tell whether it exists.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assistantServiceGetThread(
      id: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerAssistantThread> {
      return localVarFp
        .assistantServiceGetThread(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns the whole thread in order, tool calls included: without them the conversation reads as if answers appeared out of nowhere.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assistantServiceListMessages(
      id: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerListMessagesResponse> {
      return localVarFp
        .assistantServiceListMessages(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists the caller\'s own threads, newest activity first. Filter by context to get the conversations that belong to the screen the person is on.
     * @param {AssistantServiceListThreadsContextTypeEnum} [contextType] Both empty — every thread of the caller. Set together to narrow down to one screen.   - ASSISTANT_CONTEXT_TYPE_NONE: Started from nowhere in particular — the command palette on a general screen.
     * @param {string} [contextKey]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assistantServiceListThreads(
      contextType?: AssistantServiceListThreadsContextTypeEnum,
      contextKey?: string,
      limit?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<TrackerListThreadsResponse> {
      return localVarFp
        .assistantServiceListThreads(contextType, contextKey, limit, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * AssistantServiceApi - object-oriented interface
 */
export class AssistantServiceApi extends BaseAPI {
  /**
   *
   * @summary Opens a conversation about a context: an issue, a project, a page, or nothing in particular.
   * @param {TrackerCreateThreadRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public assistantServiceCreateThread(
    body: TrackerCreateThreadRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AssistantServiceApiFp(this.configuration)
      .assistantServiceCreateThread(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Deletes a thread with its messages. Nothing here is worth keeping against the owner\'s wish.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public assistantServiceDeleteThread(id: string, options?: RawAxiosRequestConfig) {
    return AssistantServiceApiFp(this.configuration)
      .assistantServiceDeleteThread(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns one thread. Someone else\'s thread reads as missing, not as denied: the answer must not tell whether it exists.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public assistantServiceGetThread(id: string, options?: RawAxiosRequestConfig) {
    return AssistantServiceApiFp(this.configuration)
      .assistantServiceGetThread(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns the whole thread in order, tool calls included: without them the conversation reads as if answers appeared out of nowhere.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public assistantServiceListMessages(id: string, options?: RawAxiosRequestConfig) {
    return AssistantServiceApiFp(this.configuration)
      .assistantServiceListMessages(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists the caller\'s own threads, newest activity first. Filter by context to get the conversations that belong to the screen the person is on.
   * @param {AssistantServiceListThreadsContextTypeEnum} [contextType] Both empty — every thread of the caller. Set together to narrow down to one screen.   - ASSISTANT_CONTEXT_TYPE_NONE: Started from nowhere in particular — the command palette on a general screen.
   * @param {string} [contextKey]
   * @param {number} [limit]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public assistantServiceListThreads(
    contextType?: AssistantServiceListThreadsContextTypeEnum,
    contextKey?: string,
    limit?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return AssistantServiceApiFp(this.configuration)
      .assistantServiceListThreads(contextType, contextKey, limit, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

export const AssistantServiceListThreadsContextTypeEnum = {
  AssistantContextTypeUnspecified: 'ASSISTANT_CONTEXT_TYPE_UNSPECIFIED',
  AssistantContextTypeIssue: 'ASSISTANT_CONTEXT_TYPE_ISSUE',
  AssistantContextTypeProject: 'ASSISTANT_CONTEXT_TYPE_PROJECT',
  AssistantContextTypePage: 'ASSISTANT_CONTEXT_TYPE_PAGE',
  AssistantContextTypeNone: 'ASSISTANT_CONTEXT_TYPE_NONE',
} as const
export type AssistantServiceListThreadsContextTypeEnum =
  (typeof AssistantServiceListThreadsContextTypeEnum)[keyof typeof AssistantServiceListThreadsContextTypeEnum]
